import LoadingButton from '@mui/lab/LoadingButton';
import { Form } from 'react-final-form';
import { Stack } from '@mui/material';

import { Button, InfoDialog, TextField } from '@occc-app/design-system';
import { AllowListPhoneNumberFragment } from '@occc/graphql';
import { formatPhoneNumberNationalForUS } from '@occc/utils-phone-number';

import { UpsertAllowListPhoneNumberFormValues } from './create-comment-modal.types';
import { UpsertAllowListPhoneNumberValidation } from './create-comment-modal.validation';
import { useUpsertPhoneNumberModalContainer } from './use-upsert-phone-number.modal-container.hook';

type UpsertPhoneNumberModalContainerProps = {
  isCreateMode: boolean;
  isOpen: boolean;
  onClose(): void;
  existingEntity?: AllowListPhoneNumberFragment;
};

export const UpsertPhoneNumberModalContainer = ({
  isOpen,
  onClose,
  existingEntity,
  isCreateMode,
}: UpsertPhoneNumberModalContainerProps) => {
  const { modalTitle, handleSubmit, initialValues, submitButtonTitle } =
    useUpsertPhoneNumberModalContainer({ existingEntity, onClose, isCreateMode });

  return (
    <InfoDialog dialogTitle={modalTitle} onClose={onClose} open={isOpen} fullWidth>
      <Form<UpsertAllowListPhoneNumberFormValues>
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validate={UpsertAllowListPhoneNumberValidation}
        render={(props) => (
          <Stack spacing={2} component='form' onSubmit={props.handleSubmit}>
            <TextField
              name={'phoneNumber' satisfies keyof UpsertAllowListPhoneNumberFormValues}
              label='Phone Number *'
              disabled={!isCreateMode}
              fieldProps={{
                // Trying to fix component going from controlled to uncontrolled because formatPhoneNumberNationalForUS returns undefined
                format: (value: unknown) => formatPhoneNumberNationalForUS(value as string) || '',
              }}
            />
            <TextField
              name={'name' satisfies keyof UpsertAllowListPhoneNumberFormValues}
              label='Member Name *'
            />
            <TextField
              name={'reason' satisfies keyof UpsertAllowListPhoneNumberFormValues}
              label='Reason for Adding *'
            />

            <Stack direction='row' spacing={2} justifyContent='flex-end'>
              <Button variant='outlined' onClick={onClose}>
                Cancel
              </Button>

              <LoadingButton
                loading={props.submitting}
                variant='contained'
                type='submit'
                disabled={props.submitting || props.hasValidationErrors || props.pristine}
              >
                {submitButtonTitle}
              </LoadingButton>
            </Stack>
          </Stack>
        )}
      />
    </InfoDialog>
  );
};
